import React from "react";
import { LoginHeader } from "../account/loginHeader";
import { LoginForm } from "../account/loginForm";
import { LoginFooter } from "../account/loginFooter";

export const Login = (props) => {
    return (
        <div className="login">
            <LoginHeader></LoginHeader>
            <LoginForm></LoginForm>
            <LoginFooter></LoginFooter>
        </div>
    );
};